import { type AxiosRequestConfig } from 'axios'
import { type IFormData } from '../pages/SignUpPage'

const signUp = (data: IFormData): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/auth/sign-up',
    data,
  }
}

export { signUp }
